import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base-name-avatar',
  templateUrl: './base-name-avatar.component.html',
  styleUrls: ['./base-name-avatar.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BaseNameAvatarComponent {
  @Input() name!: string | any;
  @Input() size = 'small';

  getInitials = (fullName: string) => {
    if (fullName) {
      const separated = fullName.split(' ');
      if (separated.length === 2) {
        return `${separated[0].charAt(0)}${separated[1].charAt(0)}`;
      }
      return separated[0].charAt(0);
    } else {
      return '--';
    }
  };
}
